// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__HicaS","spin":"spinner_spin__dn-vr"};